module.exports = __webpack_public_path__ + "img/DE00449.7073391b.png";